/* src/app/shared/carousel/carousel-basic.component.scss */
.image-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: none;
  background-color: rgba(0, 0, 0, 0);
  z-index: 100;
  pointer-events: auto;
}
.image-overlay.focused {
  display: block;
}
@media screen and (orientation: portrait) {
  .inner-item {
    text-align: center;
  }
  .inner-item img {
    margin: 0 auto;
  }
  .carousel-inner {
    align-content: center;
  }
  .carousel-indicators [data-bs-target] {
    background-color: #5f96ba !important;
  }
  .carousel-control-prev,
  .carousel-control-next {
    z-index: 2;
  }
  .first .carousel-control-prev {
    display: none !important;
  }
  .last .carousel-control-next {
    display: none !important;
  }
  .image-focus {
    cursor: pointer;
    transition: transform 0.3s;
  }
  .image-focus img {
    max-width: 100%;
    max-height: 100%;
    padding-left: 13%;
    width: 295px;
    height: 450px;
  }
  .image-focus.focused {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 9999;
    transform: scale(1);
    overflow: hidden;
  }
  .image-container.focused {
    height: 100%;
    width: auto;
    padding: 20px 0;
  }
  .image-focus.focused img {
    padding: 0;
    object-fit: contain;
    height: 100%;
    width: auto;
  }
}
@media screen and (orientation: landscape) {
  .carousel-inner {
    align-content: center;
  }
  .inner-item {
    text-align: center;
  }
  .inner-item img {
    width: 600px;
    height: 480px;
  }
  .carousel-indicators [data-bs-target] {
    background-color: #5f96ba !important;
  }
  .carousel-control-prev,
  .carousel-control-next {
    z-index: 2;
  }
  .first .carousel-control-prev {
    display: none !important;
  }
  .last .carousel-control-next {
    display: none !important;
  }
  .image-focus {
    cursor: pointer;
    transition: transform 0.3s;
    width: 100;
    height: auto;
  }
  .image-focus img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    width: calc(100% - 20px);
  }
  .image-focus.focused {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 9999;
    transform: scale(1);
    overflow: hidden;
  }
  .image-focus.focused img {
    padding: 0;
    object-fit: cover;
    height: 100%;
    width: auto;
  }
  .image-container.focused {
    height: 100%;
    overflow: hidden;
    width: 400px;
    position: relative;
    display: flex;
    justify-content: center;
  }
}
/*# sourceMappingURL=carousel-basic.component.css.map */
